import React from 'react';
import { AppBar, Toolbar, Typography, Box, IconButton, Chip, Avatar } from '@mui/material';
import { Menu as MenuIcon, Search, FilterList, AccountCircle } from '@mui/icons-material';
import NotificationDropdown from '../common/NotificationDropdown';
import LanguageSelector from '../LanguageSelector';

const Header = ({ getPageTitle, currentPage, handleDrawerToggle, handleProfileMenuOpen }) => (
  <AppBar
    position="fixed"
    sx={{
      width: { sm: `calc(100% - 240px)` },
      ml: { sm: `240px` },
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
    }}
  >
    <Toolbar>
      <IconButton
        color="inherit"
        aria-label="open drawer"
        edge="start"
        onClick={handleDrawerToggle}
        sx={{ mr: 2, display: { sm: 'none' } }}
      >
        <MenuIcon />
      </IconButton>
      <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center', gap: 2 }}>
        <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#DC143C' }}>
          {getPageTitle()}
        </Typography>
        {currentPage === 'main' && (
          <Chip 
            label="Live" 
            size="small" 
            sx={{ backgroundColor: '#4CAF50', color: 'white', fontSize: '0.7rem' }} 
          />
        )}
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        {currentPage === 'main' && (
          <>
            <IconButton color="inherit">
              <Search />
            </IconButton>
            <IconButton color="inherit">
              <FilterList />
            </IconButton>
            <LanguageSelector />
            <NotificationDropdown />
          </>
        )}
        {currentPage !== 'main' && (
          <LanguageSelector />
        )}
        <IconButton onClick={(e) => handleProfileMenuOpen(e)} color="inherit">
          <Avatar sx={{ width: 32, height: 32, bgcolor: '#DC143C' }}>
            <AccountCircle />
          </Avatar>
        </IconButton>
      </Box>
    </Toolbar>
  </AppBar>
);

export default Header;


